import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  AfterContentInit,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpInterface, LicenseDTO } from '../../api/plyca-dtos-v2';
import { FormConfig } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { PlycaDataService } from '../../../services/plyca.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { Configuration } from '../../conf/app.constants';
import { ServiceLocator } from '../../ServiceLocator';
import { FileDetailsDTO } from '../../api/plyca-dtos';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { finalize, switchMap } from 'rxjs/operators';



export class ViewDTOModal extends HelpInterface {
  public licenseDTOItem: LicenseDTO;
  public resourceJson: string;
  protected helpService: HelpService;
  constructor(
    public licenseDTO: LicenseDTO,
    public resourceJsonItem: string) {
    super();
    this.licenseDTOItem = licenseDTO;
    this.resourceJson = resourceJsonItem;

  }
}


@Component({
  selector: 'licensePanelAdmin',
  templateUrl: 'licensePanelAdmin.template.html'
})
export class LicensePanelAdminComponent extends BaseComponent
  implements AfterContentInit, OnDestroy {

  translate: TranslateService;
  locale: string;
  loaded = false;
  licenseDTO: LicenseDTO;
  editing = false;
  formConfig: FormConfig;
  resourceJson: string;
  tagsParent: string[] = [];
  windowHash: string;


  @ViewChild('formContainer', { read: ViewContainerRef, static: true })
  formContainer: ViewContainerRef;
  form: formPlycaComponent;
  esAltaEmpresa = false;

  constructor(
    public uiService: UIService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected plycaService: PlycaDataService,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private plycaErrorHandler: PlycaErrorHandler,
    protected configuration: Configuration,

    private elem: ElementRef
  ) {
    super();
    this.init();
  }

  init(): void {
    this.translate = ServiceLocator.injector.get(TranslateService);

    this.helpService.getStoreTagsObservable().pipe(
      switchMap((helpTags) => this.tagsParent = helpTags)).subscribe();

    this.windowHash = generateRandomIdentifier();

    //this.resourceJson = this.dialogConfig['item'].resourceJson;
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.LICENSE_NEW));

  }

  addFileItem(fileItem: FileDetailsDTO) {

    let license = new LicenseDTO();
    license.identifierFile = fileItem.identifier;

    this.subscribe(
      this.plycaService.insert<LicenseDTO>(this.configuration.LICENSE_PLATFORM_SERVICE_URL, license),
      response => {
        console.log('Insertado licencia...');
        license = response;
        //this.favouriteVisible = true;
        console.log('insertado ');
        this.closeWindow();
      },
      error => {
        this.plycaErrorHandler.showServerError(error);
      }
    );

  }

  ngAfterContentInit(): void {
    this.load();
  }

  load() {
    //this.selectLicense(this.resourceJson);
    this.loaded = true;
  }

  showErrors(err: any) {
    this.plycaErrorHandler.showServerError(err);
  }

  isEditing(): boolean {
    return this.editing;
  }

  closeWindow() {
    try {
      this.ref.close();
    } catch (e) {
      console.log(e);
    }

  }


  ngOnDestroy() {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);
      })));
  }

  isLoaded() {
    return this.loaded;
  }
}
